import React, { useEffect, useRef, useState } from "react";
import { IPaginacion } from "../../Interfaces/filter";
import {
  IDataTableTipoEquipo,
  IFilterTableTipoEquipo,
  InitialFilterTableTipoEquipo,
} from "../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import TipoEquipoService from "../../services/ListaVerificacion/TipoEquipoService";
import { IException } from "../../Interfaces/base/IBase";
import { ISearchBox } from "@fluentui/react";

export const useTableTipoEquipo = () => {
  const [loading, setLoading] = useState(false);
  const controllerRef = useRef<AbortController>(new AbortController());
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [dataItems, setDataItems] = useState<IDataTableTipoEquipo[]>([]);
  const [filter, setFilter] = useState<IFilterTableTipoEquipo>(
    InitialFilterTableTipoEquipo
  );

  const searchBoxRefTable = useRef<ISearchBox>(null);

  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const postDataTableTipoEquipo = () => {
    setLoading(true);
    controllerRef.current?.abort()
    const newAbortController = new AbortController();
    controllerRef.current = newAbortController

    TipoEquipoService.PostListarTable(filter,newAbortController)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setDataItems(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
        console.log(err);
      });
  };
  const onClickRefresh = () => {
    if (filter.search !== "") {
      setFilter(InitialFilterTableTipoEquipo);
    } else {
      postDataTableTipoEquipo();
    }
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    postDataTableTipoEquipo();
  }, [filter]);

  return {
    loading,
    onClickRefresh,
    paginacion,
    dataItems,
    searchBoxRefTable,
    _onkeyUpSearch,
    onChangeSkip,
  };
};
